import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Film, Lightbulb, MousePointer2, Search, ArrowRight } from 'lucide-react';
export function CorePrincipleScreen() {
  const steps = [{
    icon: Film,
    title: 'Animation',
    subtitle: 'Lean back',
    bg: 'bg-[#F3E8FF]',
    text: 'text-purple-900',
    iconColor: 'text-purple-600',
    size: 'p-6 min-h-[160px]',
    width: 'w-full md:w-1/4'
  }, {
    icon: Lightbulb,
    title: 'Instant clarity',
    subtitle: 'I recognize this',
    bg: 'bg-[#E9D5FF]',
    text: 'text-purple-900',
    iconColor: 'text-purple-700',
    size: 'p-8 min-h-[200px]',
    width: 'w-full md:w-1/4'
  }, {
    icon: MousePointer2,
    title: 'First interaction',
    subtitle: "I'll try this",
    bg: 'bg-[#C4B5FD]',
    text: 'text-purple-950',
    iconColor: 'text-purple-800',
    size: 'p-10 min-h-[240px]',
    width: 'w-full md:w-1/4'
  }, {
    icon: Search,
    title: 'Deeper exploration',
    subtitle: 'Show me more',
    bg: 'bg-[#7C3AED]',
    text: 'text-white',
    iconColor: 'text-white',
    size: 'p-12 min-h-[280px]',
    width: 'w-full md:w-1/4'
  }];
  return <section className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6 py-20" data-id="element-136">
      <div className="max-w-6xl w-full mx-auto flex flex-col items-center" data-id="element-137">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-20" data-id="element-138">
          Give value before asking for effort
        </motion.h2>

        <div className="flex flex-col md:flex-row items-center justify-center w-full gap-4 md:gap-2 mb-20" data-id="element-139">
          {steps.map((step, index) => <Fragment key={index} data-id="element-140">
              <motion.div initial={{
            opacity: 0,
            x: -20,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            x: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.5
          }} className={`${step.width} ${step.bg} ${step.text} ${step.size} rounded-2xl flex flex-col justify-center shadow-sm relative group transition-transform hover:-translate-y-2`} data-id="element-141">
                <step.icon size={32} className={`${step.iconColor} mb-4`} data-id="element-142" />
                <h3 className="font-bold text-lg md:text-xl mb-1" data-id="element-143">
                  {step.title}
                </h3>
                <p className="opacity-80 font-medium text-sm md:text-base" data-id="element-144">
                  "{step.subtitle}"
                </p>
              </motion.div>

              {index < steps.length - 1 && <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2 + 0.1
          }} className="hidden md:flex text-slate-300 shrink-0" data-id="element-145">
                  <ArrowRight size={24} data-id="element-146" />
                </motion.div>}
            </Fragment>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1
      }} className="text-xl text-slate-500 text-center font-medium" data-id="element-147">
          Effort increases only when reward is proven
        </motion.p>
      </div>
    </section>;
}